import fr from '@vee-validate/i18n/dist/locale/fr.json';
import { localize } from '@vee-validate/i18n';
import { defineRule, configure } from 'vee-validate';
import { createApp } from 'vue';

import PageLogin from './pages/page-login/PageUserLoginComponent.vue'

import MenuMain from './component/menus/menu-main/MenuMain.vue'
import MenuFooter from './component/menus/menu-footer/MenuFooter.vue'
import MenuSignature from './component/menus/menu-signature/MenuSignature.vue'
import MenuDisclaimer from './component/menus/menu-disclaimer/MenuDisclaimer.vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from "swiper/modules";
import BlockSearch from './component/block-search/BlockSearch.vue'
import BlockNewsletter from './component/block-newsletter/BlockNewsletter.vue'
import mitt from 'mitt';
import VueMitter from '@nguyenshort/vue3-mitt'
import Locator from './common/components/locator/Locator.vue'

import Page from './layout/Page.vue'
import PageAlways from './pages/node-always/PageAlways.vue'
import PageArticle from './pages/node-article/PageArticle.vue'
import PageArticleLibre from './pages/node-article-libre/PageArticleLibre.vue'
import PageCalculator from './pages/node-calculator/PageCalculator.vue'
import PageChange from './pages/node-change/PageChange.vue'
import PageComparator from './pages/node-comparator/PageComparator.vue'
import PageContact from './pages/node-contact/PageContact.vue'
import PageFAQ from './pages/node-faq/PageFAQ.vue'
import PageFind from './pages/node-find/PageFind.vue'
import PageHomepage from './pages/node-homepage/PageHomepage.vue'
import PageOffer from './pages/node-offer/PageOffer.vue'
import PageOffersCollection from './pages/node-offers-collection/PageOffersCollection.vue'
import PageOutside from './pages/node-outside/PageOutside.vue'
import PagePhone from './pages/node-phone/PagePhone.vue'
import PageProduct from './pages/node-product/PageProduct.vue'
import PageSimulator from './pages/node-simulator/PageSimulator.vue'
import PageSolution from './pages/node-solution/PageSolution.vue'
import PageSubscription from './pages/node-subscription/PageSubscription.vue'
import PageTankCollection from './pages/node-tank-collection/PageTankCollection.vue'
import PageCylinderCollection from './pages/node-cylinder-collection/PageCylinderCollection.vue'
import PageHousingHeating from './pages/node-housing-heating/PageHousingHeating.vue'
import HubArticleV2 from './pages/node-hub-article-v2/HubArticleV2.vue'
import PageFormQualification from './pages/node-form-qualification/PageFormQualification.vue'
import PageFormRh from './pages/form-rh/PageFormRh.vue'
import PageFormSatisfaction from './pages/node-form-satisfaction/PageFormSatisfaction.vue'
import PageFormUnsubscribe from './pages/node-form-unsubscribe/PageFormUnsubscribe.vue'
import PageLandingBoat from './pages/node-landing-boat/PageLandingBoat.vue'
import PageLandingFioul from './pages/node-landing-fioul/PageLandingFioul.vue'
import PageLandingFioulProfessionnel from './pages/node-landing-fioul-professionnel/PageLandingFioulProfessionnel.vue'
import PageArticleForm from './pages/node-article-form/PageArticleForm.vue'
import PageAideContact from './pages/node-aide-contact/PageAideContact.vue'
import PageLandingCereal from './pages/node-landing-cereal/PageLandingCereal.vue'
import PageLandingGenerique from "./pages/node-landing-generique/PageLandingGenerique.vue";
import PageLandingElectricite from "./pages/node-landing-electricite/PageLandingElectricite";
import PageLandingElectriciteCHR from "./pages/node-landing-electricite/landing-electricite-chr/PageLandingElectriciteCHR";
import PageLandingElectriciteGenerique from "./pages/node-landing-electricite/landing-electricite-generique/PageLandingElectriciteGenerique";
import PageLandingElectriciteGerantPME from "./pages/node-landing-electricite/landing-electricite-gerant-pme/PageLandingElectriciteGerantPME";
import PageLandingElectriciteSyndicatCopropriete from "./pages/node-landing-electricite/landing-electricite-syndicat-copropriete/PageLandingElectriciteSyndicatCopropriete";
import PageLandingLivreBlanc from "./pages/node-landing-livre-blanc/PageLandingLivreBlanc.vue";
import PageLBChangerFournisseur from "./pages/node-lb-changer-fournisseur/PageLBChangerFournisseur.vue";
import PageLivreBlanc from "./pages/node-livre-blanc/PageLivreBlanc.vue";
import PageHubOffres from "./pages/node-hub-offres/HubOffres.vue";
import ViewSticky from './component/view-sticky/ViewSticky.vue'
import PageMaintenance from './pages/page-maintenance/PageMaintenance.vue'
import Page404 from './pages/page-404/Page404.vue'
import PageSearch from './pages/page-search/PageSearch.vue'
import PageSitemap from './pages/page-sitemap/PageSitemap.vue'

import ParagraphCard from './component/paragraph-card/ParagraphCard.vue'
import ParagraphArticleForm from './component/paragraphs/article_form/ParagraphArticleForm.vue'
import ParagraphTabPrime from './component/paragraph-tab-prime/ParagraphTabPrime.vue'

import ViewNewsfeed from './component/view-newsfeed/ViewNewsfeed.vue'
import ViewProducts from './component/view-products/ViewProducts.vue'
import ViewOffers from './component/view-offers/ViewOffers.vue'

import faqDirective from './directive/FaqDirective'
import faqSearchDirective from './directive/FaqSearchDirective'
import axios from 'axios'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './common/app.sass'

// Configure VeeValidate
configure({
  generateMessage: localize('fr', fr)
});

// Define custom rule using defineRule
defineRule('email_dummy', (value) => {
  return axios.get(`https://apilayer.net/api/check?access_key=605586746eaa95868abdde43522a27b9&smtp=1&email=${value}`)
    .then(response => {
      return response.data && response.data.success ? response.data.smtp_check && response.data.format_valid : { valid: true };
    })
    .catch(() => 'email');
});


// ticket 204 : remove double loading of image in home page flux d'actualités
// document.querySelectorAll('.image-fit').forEach(imageWrapper => {
//   const imgSrc = imageWrapper.querySelector('img').src
//   if (imgSrc) {
//     imageWrapper.classList.add('background-fit')
//     imageWrapper.style.backgroundImage = `url(${imgSrc})`
//   }
// });

// Create the Vue application
const app = createApp({
  mounted() {
    document.getElementById('app').classList.remove('loading')

    // Manage YouTube videos in content editor...
    const videoIframes = document.querySelectorAll('iframe');
    const regex = /youtu\.?be(\.com)?/;

    const emmiter = mitt()

    videoIframes.forEach(videoIframe => {
      if (videoIframe.src.match(regex) || ('src' in videoIframe.dataset && videoIframe.dataset.src.match(regex))) {
        // Add classes and CSS to YouTube iframe
        videoIframe.classList.add('optanon-category-C0004-C0002-C0003');

        // Set data-src with src
        if (!('src' in videoIframe.dataset)) {
          videoIframe.dataset.src = videoIframe.src;
          videoIframe.attributes.removeNamedItem('src');
        }

        // Set a video container
        const videoContainer = document.createElement('div');
        videoContainer.classList.add('video');
        videoContainer.style.overflow = 'hidden';
        videoContainer.style.marginBottom = '1.75rem';
        videoContainer.style.maxWidth = '100%';

        // Set the text block with button
        const hiddenBlock = document.createElement('div');
        hiddenBlock.classList.add('youtube-hidden');

        const hiddenBlockText = document.createElement('p');
        hiddenBlockText.innerText = 'Le visionnage de cette vidéo entraîne un dépôt de cookies de la part de YouTube. Si vous souhaitez lire la vidéo, vous devez consentir aux cookies en cliquant sur le bouton ci-dessous.';

        const hiddenBlockButton = document.createElement('button');
        hiddenBlockButton.setAttribute('id', 'ot-sdk-btn');
        hiddenBlockButton.classList.add('ot-sdk-show-settings');
        hiddenBlockButton.style.marginTop = '10px';
        hiddenBlockButton.innerText = 'Paramètres des cookies';

        hiddenBlock.append(hiddenBlockText, hiddenBlockButton);

        const parentElement = videoIframe.parentElement;

        if (!parentElement.classList.contains('media')) {
          parentElement.classList.add('media');
        }

        videoContainer.prepend(hiddenBlock);
        videoIframe.parentNode.insertBefore(videoContainer, videoIframe);
        videoContainer.appendChild(videoIframe);
      }
    });

    // Hide or show YouTube video block replacement against one trust cookie
    const youtubeHiddenBlock = document.querySelector('.youtube-hidden');
    if (youtubeHiddenBlock) {
      this.manageYoutubeVideo();
    }
  },

  methods: {
    manageYoutubeVideo() {
      const youtubHiddenBlocks = document.querySelectorAll('.youtube-hidden');
      const cookieValue = document.cookie.split('; ').find(row => row.startsWith('OptanonConsent'));

      if (cookieValue !== undefined && cookieValue.includes('C0002%3A1') && cookieValue.includes('C0003%3A1') && cookieValue.includes('C0004%3A1')) {
        // Show if categories have been accepted
        youtubHiddenBlocks.forEach(el => el.style.display = 'none');
      } else {
        // Hide if categories have not been accepted
        youtubHiddenBlocks.forEach(el => el.style.display = 'block');
      }
    }
  }
});

app.config.globalProperties.$swiperModules = [Navigation];


app.component('page', Page)
app.component('locator', Locator)
app.component('page-login', PageLogin)
app.component('view-sticky', ViewSticky)
app.component('menu-main', MenuMain)
app.component('menu-pro', MenuMain)
app.component('menu-footer', MenuFooter)
app.component('menu-footer-pro', MenuFooter)
app.component('menu-signature', MenuSignature)
app.component('menu-disclaimer', MenuDisclaimer)
app.component('Swiper', Swiper);
app.component('SwiperSlide', SwiperSlide);
app.component('block-search', BlockSearch)
app.component('block-newsletter', BlockNewsletter)

app.component('hub-article-v2', HubArticleV2)

app.component('page-always', PageAlways)
app.component('page-article', PageArticle)
app.component('page-article-libre', PageArticleLibre)
app.component('page-calculator', PageCalculator)
app.component('page-change', PageChange)
app.component('page-comparator', PageComparator)
app.component('page-contact', PageContact)
app.component('page-faq', PageFAQ)
app.component('page-find', PageFind)
app.component('page-homepage', PageHomepage)
app.component('page-offer', PageOffer)
app.component('page-offers-collection', PageOffersCollection)
app.component('page-outside', PageOutside)
app.component('page-phone', PagePhone)
app.component('page-product', PageProduct)
app.component('page-simulator', PageSimulator)
app.component('page-solution', PageSolution)
app.component('page-subscription', PageSubscription)
app.component('page-tank-collection', PageTankCollection)
app.component('page-cylinder-collection', PageCylinderCollection)
app.component('page-housing-heating', PageHousingHeating)
app.component('page-form-qualification', PageFormQualification)
app.component('page-form-rh', PageFormRh)
app.component('page-form-satisfaction', PageFormSatisfaction)
app.component('page-form-unsubscribe', PageFormUnsubscribe)
app.component('page-landing-boat', PageLandingBoat)
app.component('page-landing-fioul', PageLandingFioul)
app.component('page-landing-fioul-professionnel', PageLandingFioulProfessionnel)
app.component('page-landing-generique', PageLandingGenerique)
app.component('page-landing-electricite', PageLandingElectricite)
app.component('page-landing-electricite-chr', PageLandingElectriciteCHR)
app.component('page-landing-electricite-generique', PageLandingElectriciteGenerique)
app.component('page-landing-electricite-gerant-pme', PageLandingElectriciteGerantPME)
app.component('page-landing-electricite-syndic-copro', PageLandingElectriciteSyndicatCopropriete)
app.component('page-article-form', PageArticleForm)
app.component('page-aide-contact', PageAideContact)
app.component('page-landing-cereal', PageLandingCereal)
app.component('page-landing-livre-blanc', PageLandingLivreBlanc)
app.component('page-lb-changer-fournisseur', PageLBChangerFournisseur)
app.component('page-livre-blanc', PageLivreBlanc)
app.component('page-hub-offres', PageHubOffres)

app.component('page-search', PageSearch)
app.component('page404', Page404)
app.component('page-maintenance', PageMaintenance)
app.component('page-sitemap', PageSitemap)

app.component('paragraph-card', ParagraphCard)
app.component('paragraph-article-form', ParagraphArticleForm)
app.component('paragraph-tab-prime', ParagraphTabPrime)

app.component('view-newsfeed', ViewNewsfeed)
app.component('view-products', ViewProducts)
app.component('view-offers', ViewOffers)

app.directive('faq', faqDirective)
app.directive('faq-search', faqSearchDirective)
// Vue.directive('bridge', bridgeDirective)

import bowser from 'bowser'

// IE / Edge identification
if (bowser.msie || bowser.msedge) {
  if (document.body.classList) {
    document.body.classList.add('ie')
  } else {
    document.body.className += ' ' + 'ie'
  }
}

app.use(ElementPlus)
app.use(store)
app.use(VueMitter)

// Mount the app
app.mount('#app');


